<template>
	<div class="form-group">
	    <label :for="'input'+content.contenttype"><strong v-if="!name || name == ''">{{content.contenttype}}</strong><strong v-else>{{ name }}</strong></label> 
	    <div>
            <uploadfile v-model="content.contentvalue" :height="250" @onUploaded="saveContent"></uploadfile>   
        </div>
	</div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import api from '@/api'
import uploadfile from '@/components/elements/uploadfile'

export default{
	props:['value','name'],
	data: function(){
		return {
			content: this.value
		}
    },
    components: {
        uploadfile
    },
	methods: {
		saveContent: function(){
			let vm = this

			api.updateConfig(vm.content,function(error,response){
                if (error) {
                    console.error(error)
                    return
                }
            })
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/view/setting/input/InputImage.vue